const API_VERSION = "v1";
const ASSET_VERSION = "v1";

const apiBase = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") ?? "";
/** In dev, empty VITE_API_BASE_URL uses same-origin `/api` so Vite can proxy to the backend (avoids CORS). */
export const BACK_END_URL =
  apiBase !== "" ? `${apiBase}/api` : import.meta.env.DEV ? "/api" : "";

const projectSlug = import.meta.env.VITE_PROJECT_NAME ?? "r3-mydas";
const assetBase =
  import.meta.env.VITE_ASSET_BASE_URL?.replace(/\/$/, "") ||
  `https://asset-handler.${projectSlug}.rid-intrasoft.eu`;
export const ASSET_URL = `${assetBase}/api/${ASSET_VERSION}/asset`;

export { API_VERSION };

export const MARKETPLACE_PUBLIC_ORIGIN =
  import.meta.env.VITE_MARKETPLACE_PUBLIC_URL?.replace(/\/$/, "") ?? "";

const dppRegistryBase =
  import.meta.env.VITE_DPP_REGISTRY_BASE_URL?.replace(/\/$/, "") ?? "";
/** Empty VITE_DPP_REGISTRY_BASE_URL uses same-origin `/dpp-registry` (Vite in
 *  local dev, nginx in the Docker image). Do not set this to an http:// IP in
 *  Jenkins — HTTPS pages cannot call HTTP origins (mixed content). */
export const DPP_REGISTRY_URL =
  dppRegistryBase !== "" ? dppRegistryBase : "/dpp-registry";

export const ENDPOINTS = {
  SOCIAL_MEDIA: "social-media",
};

export const ENDPOINT_BASE = {
  APP_CONFIGURATION: "/app-configuration",
  /** User prefs: `GET .../byKeycloakUserId/{sub}`, `PUT .../{numericId}` (see backend routes). */
  USER_CONFIGURATION: "/user-configuration",
  PRODUCT: "/product",
  CATEGORY: "/category",
  ORDER: "/order/",
  ORDER_ITEM: "/order-item/",
  RATING: "/rating/",
  RANKING: "/ranking/",
  REVIEW: "/review/",
  SOCIAL_MEDIA: "/social-media",
  ASSET: "/asset/",
  MANUFACTURER: "/manufacturer",
  TAG: "/tag",
  HISTORICAL_DATA: "/historical-data",
  PRODUCT_WORKER_SKILLS: "/product-worker-skills",
  WORKER_SKILLS_REQUEST: "/worker-skills-request",
  PRODUCT_PROPERTY: "/product-property",
  INSTALLATION_REQUIREMENTS: "/installation-requirements",
  PROCESSING_INFO: "/processing-info",
  AI_DS_DT_REQUEST: "/factory-owner-requirements-request",
  PROPERTY: "/property",
  CART: "/cart",
  IMAGE: "/image",
  EQUIPMENT_CAPABILITIES: "/product-capabilities",
  EXTERNAL_PRODUCT_RECORDS: "/external-product-records",
  PRODUCT_REQUEST_PROPERTY: "/product-request-property",
  PRODUCT_REQUEST_CAPABILITIES: "/capabilities-request",
  PRODUCT_ENVIRONMENTAL_PROPERTIES: "/environmental-properties",
  PRODUCTION_PHASE_SUPPORT_REQUEST: "/production-phase-support-request",
  PRODUCT_CONNECTION_CAPABILITIES: "/product-connection-capability",
  PROCESSING_AND_INSTALLATION_REQUEST: "/processing-and-installation-request",
  KPI_SELECTION_REQUEST: "/kpi-selection-request",
  OPERATION_REQUEST: "/matchmaking-operation",
  OPERATION_GROUP: "/matchmaking-operation-group",
  INCUMBENT_REQUEST: "/incumbent-equipment-request",
  URL: "/url",
  RESOURCE_GROUP: "/resource-group",
  MARKETPLACE_ORDERS: "/marketplace-orders",
};
